<template>
	<div>
		<h2>{{ $t('base.profile.account_information') }}</h2>
		<div class="btn-group-navigation">
			<router-link :to="{ name: 'UserProfileAccountInformation' }">{{ $t('base.profile.information') }}</router-link>
			<router-link :to="{ name: 'UserProfileAccountName' }">{{ $t('base.profile.change_name') }}</router-link>
			<router-link :to="{ name: 'UserProfileAccountEmail' }">{{ $t('base.profile.change_email') }}</router-link>
			<router-link :to="{ name: 'UserProfileAccountPassword' }">{{ $t('base.profile.change_password') }}</router-link>
			<router-link :to="{ name: 'UserProfileAccountPicture' }">{{ $t('base.profile.change_picture') }}</router-link>
		</div>
		<router-view/>
	</div>
</template>

<script>
export default {
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title('Account Information')
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/AccountInformation.vue